import { v4 as uuid } from "uuid";

import { IBadgeResource } from "../../badges";
import { EntityTypes } from "../../EntityTypes";
import { IFrameworkResource } from "../../frameworks";
import { ISkillResource } from "../../skills";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapOrderedRelationAsIRIs, RelationalValue } from "../../utils/filters";
import { ISkillDomain } from "../types";

export type ISkillDomainCreateMutationParameters = {
    title: string;
    shortTitle: string;
    skills: RelationalValue<ISkillResource>[];
    badges?: RelationalValue<IBadgeResource>[];
    frameworks?: RelationalValue<IFrameworkResource>[];
    uuid?: string;
};

export type ISkillDomainCreateMutationResult = ISkillDomain;

export const skillDomainCreateMutation: IApiMutationFunction<ISkillDomainCreateMutationParameters> = ({
    uuid: providedUuid,
    title,
    shortTitle,
    skills,
    badges,
    frameworks,
}) => {
    return {
        method: "POST",
        url: "/skill_domains",
        data: {
            title,
            shortTitle,
            skills: mapOrderedRelationAsIRIs(EntityTypes.SKILL, skills),
            badges: mapOrderedRelationAsIRIs(EntityTypes.BADGE, badges),
            frameworks: mapOrderedRelationAsIRIs(EntityTypes.FRAMEWORK, frameworks),
            uuid: providedUuid ?? uuid(),
        },
    };
};

export const useSkillDomainCreateMutation = createApiMutationHook<
    ISkillDomainCreateMutationParameters,
    ISkillDomainCreateMutationResult
>(skillDomainCreateMutation);
